@if (cartModification$ | async; as cartModification) {
  @if (isVisible) {
    <div class="alert alert-info">
      <span class="alert-icon">
        <cx-icon [type]="iconTypes.INFO"></cx-icon>
      </span>
      <span>
        {{
        'validation.' + cartModification.statusCode
        | cxTranslate
        : {
        quantity: cartModification.quantityAdded
      }
      }}
    </span>
    <button class="close" type="button" (click)="isVisible = !isVisible">
      <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
    </button>
  </div>
}
}
